import axios from 'axios'

class BatchesService {
  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    ).replace('-', '')
  }

  getBatchTypes (client) {
    let url = `${process.env.API}${client}/batch-types`
    return axios.get(url)
  }

  createBatch (client, batchDefinition) {
    let url = `${process.env.API}${client}/batches`
    return axios.post(url, batchDefinition)
  }
}

const batches = new BatchesService()

export default batches
export { batches }



// WEBPACK FOOTER //
// ./src/services/batches.service.js